import { ReactNode } from "react";
import { Card, Text } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import DocumentDetailsRow from "./DocumentDetailsRow";
import { FundAdminDocumentObjects } from "./types";

interface Props {
  cardTitle: string;
  documentList?: FundAdminDocumentObjects;
  actionComponent?: ReactNode;
}

const DocumentDetailsCard = ({ cardTitle, documentList, actionComponent }: Props) => {
  const handleGoToDownloadPage = (documentUrl: string) => {
    window.open(documentUrl);
  };

  const hasDocuments = Boolean(documentList?.length);

  return (
    <Card
      css={{ marginBottom: SPACING.LARGE }}
      data-testid="documents-card"
      title={cardTitle}
      actionComponent={actionComponent}
    >
      {hasDocuments ? (
        <>
          {documentList?.map((document) => {
            return (
              <Card
                role="button"
                data-testid="individual-document-card"
                key={document.id}
                onClick={() =>
                  handleGoToDownloadPage(document.documentVersion?.directDownloadUrl ?? "")
                }
                css={{ marginBottom: SPACING.MEDIUM }}
              >
                <DocumentDetailsRow documentName={document.documentVersion?.name} />
              </Card>
            );
          })}{" "}
        </>
      ) : (
        <Text data-testid="empty-state-text" variant="secondary-md">
          No documents uploaded
        </Text>
      )}
    </Card>
  );
};

export default DocumentDetailsCard;
